
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.6 4.605c0-.942.72-1.705 1.609-1.705h8.19L21 8.5v14.396c0 .941-.72 1.704-1.608 1.704H7.209c-.889 0-1.61-.763-1.61-1.704V4.605z","fill":"#F5B912"}}),_c('path',{attrs:{"d":"M15.4 9.826V5.2l5.6 5.6h-4.626a.974.974 0 01-.974-.974z","fill":"#FADC87"}}),_c('path',{attrs:{"d":"M9.8 13.912c0-.725.49-1.312 1.095-1.312h4.812c.604 0 1.094.587 1.094 1.312v5.775c0 .725-.49 1.313-1.094 1.313h-4.813c-.604 0-1.093-.588-1.093-1.313v-5.775z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.2 15.4h4.2v2.8h-4.2v-2.8z","fill":"#F5B912"}}),_c('path',{attrs:{"d":"M16.1 9.4l4.9 4.2V9.4h-4.9z","fill":"#C7960F"}})])
          )
        }
      }
    